module.exports = __webpack_public_path__ + "img/at.950ded46.svg";